import TaskResultLimitPanel from "Areas/Documents/documentDetails/taskResultLimitPanel";
import AddToSummaryReport, { NEW_SUMMARY_REPORT_OBJECT } from "Areas/SummaryReports/addToSummaryReport";
import { SUMMARY_REPORT_OBJECT_TYPE } from "Common/dictionaries/summaryReportObjectType";
import { ButtonWithTooltip, RefreshButton, SaveButton } from "Components/button";
import ButtonGroup from "Components/buttonGroup";
import ColorStyledBlock from "Components/colorStyledBlock";
import ScrolledDropdown from "Components/scrolledDropdown";
import { themeVariables } from "Components/theme";
import classNames from "classnames";
import React, { memo, useCallback, useMemo, useState } from "react";
import locale from "./rowActionsPanel.locale";
import Styled, { SIZES } from "./rowActionsPanel.styled";
const dictKeySelector = (e) => e.Id;
const dictTextSelector = (e) => e.Name;
const sizeValues = [
    { Id: "font-smallest", Name: parseInt(themeVariables["font-size-smallest"]) },
    { Id: "font-small", Name: parseInt(themeVariables["font-size-small"]) },
    { Id: "font-base", Name: parseInt(themeVariables["font-size-base"]) },
    { Id: "font-h5", Name: parseInt(themeVariables["font-size-h5"]) },
    { Id: "font-h4", Name: parseInt(themeVariables["font-size-h4"]) },
    { Id: "font-h3", Name: parseInt(themeVariables["font-size-h3"]) },
    { Id: "font-h2", Name: parseInt(themeVariables["font-size-h2"]) },
    { Id: "font-h1", Name: parseInt(themeVariables["font-size-h1"]) }
];
const alignmentItems = [
    {
        icon: "dx-icon-alignleft",
        key: "text-left"
    },
    {
        icon: "dx-icon-aligncenter",
        key: "text-center"
    },
    {
        icon: "dx-icon-alignright",
        key: "text-right"
    }
];
function RowActionsPanel(props) {
    var _a, _b;
    const [summaryReportObjectType, setSummaryReportObjectType] = useState(SUMMARY_REPORT_OBJECT_TYPE.TABLE_ROWS);
    const summaryReportObject = useMemo(() => ({
        ...NEW_SUMMARY_REPORT_OBJECT,
        DocumentId: props.documentId,
        SummaryReportObjectType: summaryReportObjectType
    }), [props.documentId, summaryReportObjectType]);
    const addToSummaryReportFormTabs = useMemo(() => [
        {
            key: SUMMARY_REPORT_OBJECT_TYPE.TABLE_ROWS,
            element: (React.createElement("span", { className: "grid-cols-auto with-gap-xs justify-content-center" },
                locale.TABLE,
                Boolean(props.rowsSelectedCount) && (React.createElement("div", { className: "bg-light-surface font-small pl-xxs pr-xxs text-primary-600 border-rounded-lg" }, props.rowsSelectedCount)))),
            disabled: !props.rowsSelectedCount
        },
        {
            key: SUMMARY_REPORT_OBJECT_TYPE.DOCUMENT_OBJECT_NODES,
            element: (React.createElement("span", { className: "grid-cols-auto with-gap-xxs justify-content-center" },
                locale.CARDS,
                Boolean(props.nodeSourcesSelectedCount) && (React.createElement("div", { className: "bg-light-surface font-small pl-xxs pr-xxs text-primary-600 border-rounded-lg" }, props.nodeSourcesSelectedCount)))),
            disabled: !props.nodeSourcesSelectedCount
        }
    ], [props.rowsSelectedCount, props.nodeSourcesSelectedCount]);
    const AddToSummaryReportCustomForm = useMemo(() => (React.createElement("div", null,
        React.createElement("div", { className: "font-smallest text-gray-500 pb-0_5 pt-1_5" }, locale.FORMAT),
        React.createElement("div", { className: "position-relative" },
            React.createElement(ButtonGroup, { height: SIZES.BTN_GROUP_HEIGHT, items: addToSummaryReportFormTabs, selectedItemKey: summaryReportObjectType, onItemClick: (itemData) => {
                    if (itemData.key !== summaryReportObjectType)
                        setSummaryReportObjectType(itemData.key);
                } }),
            Boolean(props.rowsSelectedCount) && !props.nodeSourcesSelectedCount && (React.createElement(Styled.DivWithTooltip, { className: "flex-box-centered-content position-absolute", popoverContent: locale.NO_NODE_SOURCES_SELECTION_HINT },
                React.createElement("div", null, "i")))),
        !props.rowsSelectedCount && !props.nodeSourcesSelectedCount && (React.createElement(ColorStyledBlock, { color: "error-message-color", bg: "error-message-bg", border: "error-message-border", className: "p-0_5 mt-0_75 font-small overflow-hidden line-height-small", height: 56 },
            React.createElement("i", { className: "icon-info-circle-filled line-height-1 mr-0_25 font-h4" }),
            locale.NO_SELECTION_HINT)))), [
        summaryReportObjectType,
        addToSummaryReportFormTabs,
        props.rowsSelectedCount,
        props.nodeSourcesSelectedCount
    ]);
    const handleAddToSummaryReportFormHiding = useCallback(() => {
        setSummaryReportObjectType(SUMMARY_REPORT_OBJECT_TYPE.TABLE_ROWS);
    }, []);
    const handleSummaryReportObjectValue = useCallback(() => props.getSummaryReportObjectValue(summaryReportObjectType), [props.getSummaryReportObjectValue, summaryReportObjectType]);
    return (React.createElement(Styled.ActionsMiniPanel, { className: classNames("bg-light-surface", props.className), hasRightSideButton: Boolean(props.rightSidePanel), panelHeight: props.rowActionsPanelHeight },
        React.createElement("div", { className: "grid-cols-auto no-gap overflow-hidden" },
            React.createElement(SaveButton, { onSave: props.onSave, disabled: props.disabled || !props.onSave, btnSize: SIZES.BTN_SIZE, className: "btn-arrow-action" }),
            React.createElement(RefreshButton, { onRefresh: props.onRefresh, disabled: props.disabled || !props.onRefresh, btnSize: SIZES.BTN_SIZE, needConfirm: Boolean(props.onSave), className: "btn-arrow-action" }),
            React.createElement("div", { className: "vertical-divider" }),
            React.createElement(Styled.BtnContainer, null,
                React.createElement(ButtonWithTooltip, { height: SIZES.BTN_SIZE, width: SIZES.BTN_SIZE, className: classNames("btn-filled ml-0_5 mr-0_5", props.isColumnChooserOpen && "dx-state-active"), onClick: props.onOpenColumnChooser, disabled: props.disabled, popoverContent: locale.COLUMN_SETTINGS },
                    React.createElement("i", { className: "icon-table-edit" }))),
            React.createElement("div", { className: "vertical-divider" }),
            React.createElement(Styled.BtnContainer, null,
                React.createElement(ScrolledDropdown, { keySelector: dictKeySelector, textSelector: dictTextSelector, caption: locale.SIZE, items: sizeValues, className: "dropdown-toggle-flex-space-between", togglerClassName: "no-border btn-filled pt-0 pb-0 pl-0_5 pr-0_5", togglerHeight: SIZES.BTN_SIZE, selectedKey: (_a = props.settings) === null || _a === void 0 ? void 0 : _a.fontSize, onSelectedChanged: (value) => props.onChangeSettings && props.onChangeSettings("fontSize", value), togglerTitle: locale.SIZE, minWidth: 70, disabled: props.disabled })),
            React.createElement("div", { className: "vertical-divider" }),
            React.createElement(Styled.BtnContainer, null,
                React.createElement(ButtonGroup, { height: SIZES.BTN_SIZE, items: alignmentItems, selectedItemKey: !props.disabled ? (_b = props.settings) === null || _b === void 0 ? void 0 : _b.alignment : undefined, onItemClick: itemData => {
                        props.onChangeSettings && props.onChangeSettings("alignment", itemData.key);
                    }, backgroundColor: "transparent", disabled: props.disabled })),
            React.createElement("div", { className: "vertical-divider" }),
            React.createElement(TaskResultLimitPanel, { className: "pl-0_75 pr-0_75 pt-0_25" })),
        React.createElement("div", { className: "pl-0_5 grid-cols-auto no-gap" },
            props.projectId && (React.createElement(Styled.BtnContainer, null,
                React.createElement(AddToSummaryReport, { className: "btn-filled mr-0_5", height: SIZES.BTN_SIZE, disabled: props.disabled || !props.canAddToSummaryReports, mainFormClassName: classNames(!props.rowsSelectedCount && !props.nodeSourcesSelectedCount && "no-pointer-events"), data: summaryReportObject, projectId: props.projectId, getValue: handleSummaryReportObjectValue, customForm: AddToSummaryReportCustomForm, onHiding: handleAddToSummaryReportFormHiding }))),
            React.createElement("div", { className: "vertical-divider" })),
        props.rightSidePanel));
}
export default memo(RowActionsPanel);
